export const colorSchemePreferences = ['light', 'dark', 'system'] as const;

export type ColorSchemePreference = (typeof colorSchemePreferences)[number];

export function isColorSchemePreference(
  value: unknown
): value is ColorSchemePreference {
  return (
    typeof value === 'string' &&
    (colorSchemePreferences as readonly string[]).includes(value)
  );
}
